

import { Injectable } from '@angular/core';
import { GridOptions } from 'ag-grid-community';

@Injectable({
	providedIn: 'root'
})
export class GridDataService {
	agGridOptions: GridOptions;
	constructor() { }
	getGridOptions() {
		this.agGridOptions = { enableCellTextSelection: true, ensureDomOrder: true, suppressRowClickSelection: true,} as any;

		
		return this.agGridOptions;
	}
}

